import { useCallback, useRef, useEffect, useState } from "react";
import { useChat } from "../context/chat.context";

export const useChatManager = (orderId, refreshCallback, isModal = false) => {
  const { registerChat, unregisterChat } = useChat();
  const [isRegistered, setIsRegistered] = useState(false);
  const currentOrderIdRef = useRef(null);

  const registerThisChat = useCallback(() => {
    if (!orderId || !refreshCallback) {
      return false;
    }

    if (currentOrderIdRef.current === orderId && isRegistered) {
      return true;
    }

    try {
      if (currentOrderIdRef.current && currentOrderIdRef.current !== orderId) {
        unregisterChat(currentOrderIdRef.current);
      }

      registerChat(orderId, refreshCallback, isModal);
      currentOrderIdRef.current = orderId;
      setIsRegistered(true);
      return true;
    } catch (error) {
      console.error("Error registering chat:", error);
      setIsRegistered(false);
      return false;
    }
  }, [orderId, refreshCallback, isModal, registerChat, unregisterChat, isRegistered]);

  const unregisterThisChat = useCallback(() => {
    if (!currentOrderIdRef.current) {
      return;
    }

    try {
      unregisterChat(currentOrderIdRef.current);
      currentOrderIdRef.current = null;
      setIsRegistered(false);
    } catch (error) {
      console.error("Error unregistering chat:", error);
    }
  }, [unregisterChat]);

  useEffect(() => {
    if (orderId && refreshCallback) {
      registerThisChat();
    } else {
      unregisterThisChat();
    }

    return () => {
      unregisterThisChat();
    };
  }, [orderId, refreshCallback, registerThisChat, unregisterThisChat]);

  return {
    registerChat: registerThisChat,
    unregisterChat: unregisterThisChat,
    isRegistered,
  };
};

export const useAutoChat = (orderId, refreshCallback, isModal = false) => {
  const { isRegistered } = useChatManager(orderId, refreshCallback, isModal);

  return isRegistered;
};

export default useChatManager;
